import { useEffect, useRef } from 'react';

import ImageInlay from '@components/ImageInlay';

import { useDeviceFrameScale } from './hooks';
import type { IDeviceFrameProps } from './types';

import style from './styles.module.scss';

const DeviceFrame = ({ deviceType, imageSrc, containerRef, sharedScale }: IDeviceFrameProps) => {
  const deviceFrameRef = useRef<HTMLDivElement | null>(null);

  // If we aren't in shared mode (one container for both devices), use the auto-scaling hook
  useDeviceFrameScale(
    deviceType,
    sharedScale ? { current: null } : (containerRef ?? { current: null }),
    deviceFrameRef
  );

  // If we are in shared mode, manually apply the sharedScale to the ref
  // ref in this case is the container which has both mobile and desktop devices.
  useEffect(() => {
    if (sharedScale !== undefined && deviceFrameRef.current) {
      deviceFrameRef.current.style.setProperty('--scale', String(sharedScale));
    }
  }, [sharedScale]);

  return (
    <div
      ref={deviceFrameRef}
      className={style[`${deviceType}-wrapper`]}
    >
      <div className={style[deviceType]}>
        <div className={style.frame}>
          <ImageInlay imageSrc={imageSrc} />
        </div>
      </div>
    </div>
  );
};

export default DeviceFrame;
